import Swiper from 'swiper';

class MobileSliders
{
    constructor ( sliderContainer )
    {
        this.sliderContainer = sliderContainer;

        this.isMobile = false;


        this.numSlides = this.sliderContainer.querySelectorAll( '.swiper-slide' );

        // 0-1 slides don't make for a very slider
        if ( this.numSlides.length < 2 )
        {
            console.info('Not enough slides for a slider');
            return;
        }

        this.handleWindowSizeChange();
    }

    handleWindowSizeChange ()
    {
        const mqMobile = window.matchMedia( '(max-width: 767px)' );

        if ( mqMobile )
        {
            mqMobile.addEventListener( 'change', this.detectMobileMode.bind( this ) );

            this.isMobile = mqMobile.matches;

            const initialResizeEventToTrigger = new Event( 'change' );
            mqMobile.dispatchEvent( initialResizeEventToTrigger );
        }
    }

    detectMobileMode ( e )
    {
        // console.log( 'detecting mobile....', e.currentTarget.matches, e );
        this.isMobile = e.currentTarget.matches;

        this.handleResize();
    }

    handleResize ()
    {

        // console.log( '[MobileSliders] Handling resize. this.isMobile is ' + (this.isMobile ? 'true' : 'false') );

        if ( this.isMobile )
        {


            // delete desktop ads


            this.setupSwiper();


        } else
        {


            if ( this.swiperInstance !== undefined )
            {
                this.swiperInstance.destroy( true, true );
            }


        }

    }

    setupSwiper ()
    {

        this.sliderContainer.classList.add( 'swiper' );


        // console.log('[MobileSliders] Setting up a mobile-only slider for ', this.sliderContainer);

        const swiperOptions = {
            // autoHeight: true,


            // Disable preloading of all images
            preloadImages : true,

            // Enable lazy loading
            lazy : {
                loadPrevNext : true,
                enabled      : true,
            },

            loop : true,

            centeredSlidesBounds : true,
            // loopedSlides   : 4,
            slidesPerView : 1.5,
            // centeredSlides : true,
            spaceBetween : 20,

        }

        this.swiperInstance = new Swiper( this.sliderContainer, swiperOptions );
    }

}

function detectSliders ()
{

    const mobileSliders = document.querySelectorAll( '.make-mobile-slider:not(.swiper-initialized)' );

    if ( mobileSliders.length > 0 )
    {
        Array.from( mobileSliders ).forEach( ms => new MobileSliders( ms ) );
    }

}


document.addEventListener( 'DOMContentLoaded', () =>
{

    window.addEventListener( 'DetectMobileSliders', detectSliders );
    const initialCheck = new Event( 'DetectMobileSliders' );
    window.dispatchEvent( initialCheck );
} );
